/* WJW 39: reuse the proven WJW collection Select options control.
   No new Quick Shop implementation, no extra prefetch, no DPO modification. */
(() => {
  'use strict';
  const mq = window.matchMedia('(max-width:749px)');
  const pdp = () => document.body.classList.contains('template-product');
  const supportedPage = () => document.body.classList.contains('template-index') || document.body.classList.contains('template-cart') || !!document.querySelector('[data-wjw-boost-results]');
  const markup = `<button type="button" class="mobile-collection-quick-add-button"><span>Select options</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4H5L7.2 14.4C7.4 15.3 8.2 16 9.1 16H17.5C18.4 16 19.2 15.4 19.5 14.6L21 8H6" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9" cy="20" r="1.4" fill="currentColor"/><circle cx="18" cy="20" r="1.4" fill="currentColor"/></svg></button>`;
  function make(handle,title) {
    const quick=document.createElement('quick-view');
    quick.className='wjw-mobile-product-quickview wjw39-standard-quickshop';
    quick.dataset.productHandle=handle;
    quick.innerHTML=markup;
    quick.querySelector('button').setAttribute('aria-label','Select options for '+title);
    return quick;
  }
  function apply(root) {
    // No additional DPO Quick View can be opened from ANY PDP, including its cart drawer.
    if (!mq.matches || !root || pdp()) return;
    // Homepage Amazon 2x2 cards. PDP Boost results page intentionally excluded.
    if (document.body.classList.contains('template-index')) {
      root.querySelectorAll('[data-wjw-boost-panel] .wjw-boost-discovery__grid > a.wjw-boost-discovery__card').forEach(card=>{
        const handle=card.querySelector('[data-product-handle]')?.dataset.productHandle;
        if (!handle || !/^[a-z0-9-]+$/i.test(handle) || card.dataset.wjwAvailable === 'false' || card.parentElement.classList.contains('wjw39-boost-shell')) return;
        const parent=card.parentNode;
        const shell=document.createElement('div');shell.className='wjw39-boost-shell';
        parent.insertBefore(shell,card);shell.appendChild(card);
        shell.appendChild(make(handle,card.getAttribute('aria-label')||'product'));
      });
    }
    // The 24-result Shop All search view uses the same WJW/Boost card markup
    // and native DPO-safe Select options control, never direct single-unit add.
    root.querySelectorAll('[data-wjw-boost-results] [data-wjw-boost-results-grid] > a.wjw-boost-discovery__card').forEach(card => {
      const handle=card.querySelector('[data-product-handle]')?.dataset.productHandle;
      if (!handle || !/^[a-z0-9-]+$/i.test(handle) || card.dataset.wjwAvailable === 'false' || card.parentElement.classList.contains('wjw39-boost-shell')) return;
      const parent=card.parentNode;
      const shell=document.createElement('div');shell.className='wjw39-boost-shell';
      parent.insertBefore(shell,card);shell.appendChild(card);
      shell.appendChild(make(handle,card.getAttribute('aria-label')||'product'));
    });
    // Collection-specific Best Sellers is a separate Boost API renderer.
    if (document.body.classList.contains('template-collection')) {
      root.querySelectorAll('[data-wjw-bestsellers-rail] > a.wjw-collection-bestsellers__card').forEach(card=>{
        const handle=card.querySelector('[data-product-handle]')?.dataset.productHandle;
        if (!handle || !/^[a-z0-9-]+$/i.test(handle) || card.dataset.wjwAvailable === 'false' || card.parentElement.classList.contains('wjw39-collection-shell')) return;
        const parent=card.parentNode;
        const shell=document.createElement('div');shell.className='wjw39-collection-shell';
        parent.insertBefore(shell,card);shell.appendChild(card);
        shell.appendChild(make(handle,card.getAttribute('aria-label')||'product'));
      });
    }
    // The original Reformation Recently Viewed and Shopify recommendation
    // components load their cards from AJAX endpoints (search.recently-viewed
    // and product_recommendations). On those endpoints template.name is not
    // the current storefront template, so Liquid cannot reliably choose when
    // to render the mobile button. Enhance only the approved homepage/cart
    // card family *after* insertion, never PDPs, never the desktop card.
    if (supportedPage()) {
      root.querySelectorAll('.wjw-shared-recommendations .wjw-reco-mobile-cell, [data-wjw38-cart-boost] .wjw-reco-mobile-cell').forEach(cell => {
        const card=cell.querySelector('.wjw-reco-mobile-card');
        const body=card?.querySelector('.wjw-reco-mobile-card__body');
        const handle=cell.dataset.wjwProductHandle;
        if (!body || !handle || !/^[a-z0-9-]+$/i.test(handle) ||
            card.dataset.wjwCardAvailable !== 'true' ||
            body.querySelector('quick-view')) return;
        const title=body.querySelector('.wjw-reco-mobile-card__title')?.textContent.trim() || 'product';
        body.appendChild(make(handle,title));
      });
    }
    // Cart Drawer: adapt the existing native recommendation Quick View markup;
    // do NOT touch grouped cart lines' DPO Change Quantities functionality.
    root.querySelectorAll('#Cart-Drawer .cart-drawer--recommendations .product-cart-item quick-view.product-card-quickview').forEach(quick=>{
      if (quick.classList.contains('wjw39-standard-quickshop')) return;
      const handle=quick.dataset.productHandle;
      if (!handle || !/^[a-z0-9-]+$/i.test(handle)) return;
      quick.classList.add('wjw39-standard-quickshop','wjw-mobile-product-quickview');
      quick.removeAttribute('tabindex');
      const text=quick.closest('.product-cart-item')?.querySelector('.cart-product-link')?.textContent.trim()||'product';
      quick.innerHTML=markup;
      quick.querySelector('button').setAttribute('aria-label','Select options for '+text);
    });
  }
  // The AJAX recommendations element inserts HTML without dispatching our
  // custom card event. Observe only the small recommendation containers,
  // never the entire document, and retain an observer per mounted section.
  const watched=new WeakSet();
  function observeShared() {
    if (!mq.matches || pdp() || !supportedPage()) return;
    document.querySelectorAll('.wjw-shared-recommendations, [data-wjw38-cart-boost]').forEach(node => {
      if (watched.has(node)) return;
      watched.add(node);
      new MutationObserver(() => apply(node)).observe(node, {childList:true,subtree:true});
    });
  }
  function run(){apply(document);observeShared();}
  document.addEventListener('wjw:cards-inserted',()=>apply(document));
  document.addEventListener('shopify:section:load',run);
  // Responsive Chrome DevTools viewport changes must initialize the same cards.
  mq.addEventListener?.('change', () => { if (mq.matches) run(); });
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
  // Only cart drawer can replace its recommendation nodes after initial load.
  function observeDrawer(){
    const drawer=document.getElementById('Cart-Drawer');if (!drawer) return;
    const obs=new MutationObserver(()=>apply(drawer));
    obs.observe(drawer,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',observeDrawer);else observeDrawer();
})();
